import { theme } from '@arpeggi/ui'
import chroma from 'chroma-js'
import ColorThief from 'colorthief'
import { useEffect, useState } from 'react'

const thief = new ColorThief()

export const useColorThief = (src: string) => {
  const [palette, setPalette] = useState<[string, string]>()
  const [gradient, setGradient] = useState<string>(theme.colors.blackA050.value)
  useEffect(() => {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.src = src + '?info=none' // workaround for cors issue
    image.addEventListener('load', () => {
      const palette: [number, number, number][] = thief.getPalette(image, 2)
      console.log(palette)
      const color1 = chroma(...palette[0])
        .alpha(0.6)
        .hex()
      const color2 = chroma(...palette[0])
        .alpha(0.1)
        .hex()
      setPalette([color1, color2])
      setGradient(`linear-gradient(180deg, ${color1} 0%, ${color2} 100%)`)
    })
  }, [src])
  return { palette, gradient }
}
